import React from 'react';
import { News, StoryObject } from '@benzinga/basic-news-manager';
import { calculateReadTime } from '@benzinga/article-manager';
import { ReadNextCard } from './ReadNextCard';

interface ReadNextProps {
  attrs?: {
    data: {
      links?: { article: StoryObject | News; text: string; href: string }[];
      news_selection_mode?: 'query' | 'manual';
      showTopBorder?: boolean;
      title?: string;
      variant?: 'banner' | 'card' | 'list';
    };
  };
}

export const ReadNextBlock: React.FC<ReadNextProps> = ({ attrs }) => {
  const { links, news_selection_mode, title, variant } = attrs?.data ?? {};

  if (!Array.isArray(links) || links.length < 1) {
    return <div />;
  }

  const showTopBorder = variant !== 'banner';

  return (
    <div className={`read-next-block my-4 ${showTopBorder ? 'border-t border-gray-200 pt-4' : ''}`}>
      <div className="read-next-block-inner">
        {title && <div className="mb-2 text-base font-bold">{title}</div>}
        <div className="read-next-cards-list">
          {links?.map((link, index) => {
            const cardTitle = news_selection_mode === 'query' ? link.article?.title : link.text;
            return (
              <ReadNextCard
                data={{
                  category: link.article?.channels?.[0]?.name ?? '',
                  image: Array.isArray(link.article?.image) ? link.article?.image[0]?.url : (link.article?.image ?? ''),
                  readTime: link.article?.body ? calculateReadTime(link.article.body) : undefined,
                  teaser: link.article?.teaser ?? '',
                  title: cardTitle ?? link.text,
                  url: link.article?.url ?? link.href,
                }}
                key={`${link.article?.url ?? link.href}-${index}`}
                variant={variant}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
